import { useEffect } from 'react';
import { Navigate, Outlet, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { locales, defaultLocale, type Locale } from '@/i18n/config';

export function LocaleLayout() {
  const { locale } = useParams<{ locale: string }>();
  const { i18n } = useTranslation();

  const isValid = locales.includes(locale as Locale);

  useEffect(() => {
    if (isValid && i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
  }, [locale, isValid, i18n]);

  if (!isValid) {
    return <Navigate to={`/${defaultLocale}/dashboard`} replace />;
  }

  return <Outlet />;
}
